<template>
  <div class="vtoOverlay" v-on="$attrs" @click="$attrs.click && $attrs.click()"></div>
</template>

<script>
export default {
  name: 'VtoOverlay',
};
</script>
